// test1733
(1733 && 0);
